export const formatSeats = (seats: Array<number>) => {
	if (!seats.length) {
		return "/";
	} else if (seats.length === 1) {
		return seats[0];
	}

	return `${seats[0]} - ${seats[seats.length - 1]}`;
};

export const convertSeatNumbersToSeats = (numbers: Array<number>): string => {
	const sortedNumbers = [...numbers].sort((a, b) => a - b);

	let rangeStart = sortedNumbers[0];
	let rangeEnd = sortedNumbers[0];
	const ranges = new Array<string>();

	for (let i = 1; i < sortedNumbers.length; i++) {
		if (sortedNumbers[i] === rangeEnd + 1) {
			rangeEnd = sortedNumbers[i];
		} else {
			ranges.push(rangeStart === rangeEnd ? `${rangeStart}` : `${rangeStart}-${rangeEnd}`);
			rangeStart = rangeEnd = sortedNumbers[i];
		}
	}
	ranges.push(rangeStart === rangeEnd ? `${rangeStart}` : `${rangeStart}-${rangeEnd}`);

	return ranges.join(", ");
};
export const groupSeatNumbersWithRange = (numbers: Array<number | string>): string => {
	if (!Array.isArray(numbers)) return "";

	const normalized = numbers.map((n) => (typeof n === "number" ? n.toString() : n?.toString())).filter(Boolean);

	const uniqueSorted = Array.from(new Set(normalized)).sort((a, b) => {
		const numA = parseInt(a, 10);
		const numB = parseInt(b, 10);
		return isNaN(numA) || isNaN(numB) ? a.localeCompare(b) : numA - numB;
	});

	const parsedNumbers = uniqueSorted.map((n) => parseInt(n, 10)).filter((n) => !isNaN(n));

	if (parsedNumbers.length === 0) return "";
	if (parsedNumbers.length === 1) return parsedNumbers[0].toString();

	const first = parsedNumbers[0];
	const last = parsedNumbers[parsedNumbers.length - 1];

	return `${first}–${last}`;
};
